import { OpportunityDTO } from '@app/src/views/StepOne/form/dtos';
import { SelectItemModel } from '@app/src/common/Select/SelectModel';

export const hydrateData = (data: OpportunityDTO[]) =>
  data.map((item) => ({
    value: String(item.id),
    text: item.name,
    data: { ...item }
  })) as SelectItemModel[]
